var path = 'src/app/patients/numbers/numbers.html';
var html = "<h1 class=page-header>Patient Numbers</h1> <div patient-numbers-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/numbers/numbers.html
 ** module id = 420
 ** module chunks = 0
 **/